import Nullstack from 'nullstack';
export default function IconTextOrientation({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-text-orientation",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 15l-5 -5c-1.367 -1.367 -1.367 -3.633 0 -5s3.633 -1.367 5 0l5 5"
  }), "   ", Nullstack.element("path", {
    d: "M5.5 11.5l5 -5"
  }), "   ", Nullstack.element("path", {
    d: "M21 12l-9 9"
  }), "   ", Nullstack.element("path", {
    d: "M21 12v4"
  }), "   ", Nullstack.element("path", {
    d: "M21 12h-4"
  }), " ");
}